import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ChannelReport" }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {useStore} from "@/store";
import {initEmptyParam} from "@/hooks/useInitParam";
import dayjs from 'dayjs'
import {getListData} from "@/service/main/system";
import PageContent from "@/components/PageContent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChannelReport',
  setup(__props) {

initEmptyParam()
const store = useStore()

const getThirdPartyList = async () => {
  let thirdPartyData = await getListData('/main/customerChannel/queryThirdParty', {})
  const thirdPartyItem = searchFormConfig.formItems.find((item) => item.field === 'thirdParty')
  thirdPartyItem!.options = thirdPartyData.map((item: any) => {
    return {title: item, value: item}
  })
}
getThirdPartyList()

const getChannelList = async () => {
  let channelData = await getListData('/main/customerChannel/queryChannelByThirdParty', {})
  const channelItem = searchFormConfig.formItems.find(item => item.field === 'sourceLabel')
  channelItem!.options = channelData.map((item: any) => {
    return {title: item, value: item}
  })
}
getChannelList()

const queryParam = {
  timeSlot: [
    dayjs().startOf('month').format('YYYY-MM-DD'),
    dayjs().endOf('date').format('YYYY-MM-DD')
  ],
  cfddFlag: false,
}
store.commit('system/changeQueyryInfo', queryParam)

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const resetCb = () => {
  return queryParam
}

const [pageContentRef, handleResetClick, handleSearchClick, handleDownBtnClick] = usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "channelReport",
      downFilename: "渠道数据报表.xlsx",
      onDownBtnClick: _unref(handleDownBtnClick),
      onSortChange: handleSortChange
    }, null, 8, ["contentTableConfig", "onDownBtnClick"])
  ]))
}
}

})